import DashBannerDesktop from './dash-banner-desktop';
export default DashBannerDesktop;
